module.exports = __webpack_public_path__ + "static/img/homeTitle1.e2a07024.png";